import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import CheckboxFields from 'components/application/CheckboxFields';

export default function TrainingStatusFilter({
  onChange,
  trainingStatusFilter,
}) {
  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  return (
    <CheckboxFields
      checkboxes={[
        {
          name: 'training_status_up_to_date',
          label: i18nTShared('upToDate'),
          value: trainingStatusFilter.valid,
          onChange: (event) => onChange('valid', event.target.checked),
        },
        {
          name: 'training_status_expiring_soon',
          label: i18nTShared('expiringSoon'),
          value: trainingStatusFilter.expiring,
          onChange: (event) => onChange('expiring', event.target.checked),
        },
        {
          name: 'training_status_expired',
          label: i18nTShared('expired'),
          value: trainingStatusFilter.expired,
          onChange: (event) => onChange('expired', event.target.checked),
        },
        {
          name: 'training_status_missing',
          label: i18nTShared('missing'),
          value: trainingStatusFilter.missing,
          onChange: (event) => onChange('missing', event.target.checked),
        },
      ]}
    />
  );
}

TrainingStatusFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  trainingStatusFilter: PropTypes.object.isRequired,
};
